import { useEffect, useState } from 'react';
import { useParams } from 'next/navigation';
import { Token } from 'shared/types/Token';
import { usePageLoader } from 'providers/loader';
import { sdk } from 'sdk';

const useSession = (cartIdProp?: string, fulfillerId?: string, showWholePageLoader: boolean = true) => {
  const params = useParams();
  const slug = params?.slug;
  const cartId = slug?.[0] === 'cart' ? slug?.[1] : (cartIdProp ?? '');
  const [session, setSession] = useState<Token | null>(null);
  const [isExpired, setIsExpired] = useState(false);
  const { showLoader, hideLoader } = usePageLoader();

  const fetchSession = async () => {
    try {
      const res = await sdk.composableCommerce.cart.getCheckoutSessionToken({
        cartId,
        fulfillerCode: fulfillerId,
      });

      if (res.isError) {
        setIsExpired(true);
        setSession(null);
        return null;
      }

      setIsExpired(false);
      setSession(res.data);

      return res.data;
    } catch (error) {
      console.error(error);
      setIsExpired(true);
      return null;
    }
  };

  useEffect(() => {
    if (!cartId) return;
    let isMounted = true;
    async function getSession() {
      try {
        if (showWholePageLoader) showLoader();

        const data = await fetchSession();

        if (!isMounted) return;

        if (!data) {
          setIsExpired(true);
        }
      } finally {
        if (showWholePageLoader) hideLoader();
      }
    }

    void getSession();

    return () => {
      isMounted = false;
    };
  }, [cartId, fulfillerId, showWholePageLoader]);

  return {
    session,
    isExpired,
    refreshSession: fetchSession,
  };
};

export default useSession;
